export const diagnosisQuestions = [
  'Confio em minha inteligência.',
  'Tenho motivação para estudar.',
  'Estudo com organização e método.',
  'Faço planejamento de estudo e mantenho equilíbrio com lazer e atividade física.',
  'Administro bem o meu tempo.',
  'Sou disciplinado e estudo com foco.',
  'Contabilizo minha produtividade.',
  'Mantenho minha ansiedade sob controle.',
  'Após aprender a matéria, utilizo técnicas de memorização.',
  'Faço revisões periódicas.'
];

export const strategicQuestions = [
  'Eu sei o que quero para minha vida?',
  'Luto com todas as forças para atingir meu objetivo?',
  'Consigo estabelecer um planejamento de estudo?',
  'Tenho disciplina e comprometimento para cumprir o planejamento?',
  'Tenho preparo psicológico e resiliência para estudos de longo prazo?',
  'Fico desmotivado quando não alcanço meus objetivos, a ponto de desistir?',
  'Fico desmotivado quando sou criticado, a ponto de desistir?',
  'Consigo me adaptar a uma maratona de estudos mesmo sabendo que terei privações?',
  'Meus estudos são eficazes?',
  'Tenho boa estratégia de estudos: estudo, exercícios e memorização?',
  'Acredito em mim e sei do meu potencial?'
];

export const lifeWheelAreas = [
  'Saúde e disposição',
  'Desenvolvimento intelectual',
  'Equilíbrio emocional',
  'Realização e propósito',
  'Recursos financeiros',
  'Contribuição social',
  'Família',
  'Desenvolvimento amoroso',
  'Vida social',
  'Criatividade, hobbies e diversão',
  'Plenitude e felicidade',
  'Espiritualidade'
];

export function classify(percentage: number) {
  if (percentage < 40) return 'Zona crítica';
  if (percentage < 60) return 'Precisa de estrutura';
  if (percentage < 80) return 'Evolução consistente';
  return 'Alta performance';
}

export function diagnosisResult(answers: number[]) {
  const total = answers.reduce((sum, value) => sum + Number(value || 0), 0);
  const percentage = Math.round((total / 50) * 1000) / 10;
  const weak = diagnosisQuestions.filter((_, index) => answers[index] <= 2).slice(0, 3);
  const strong = diagnosisQuestions.filter((_, index) => answers[index] >= 4).slice(0, 3);
  return {
    total,
    percentage,
    classification: classify(percentage),
    strong: strong.length ? strong : ['Clareza para começar um plano estruturado.'],
    attention: weak.length ? weak : ['Ajustes finos de método e revisão.'],
    recommendation:
      percentage >= 80
        ? 'Mantenha o ciclo, eleve a dificuldade dos simulados e refine revisões.'
        : percentage >= 60
          ? 'Consolide a rotina semanal, registre a execução real e aumente o volume de questões.'
          : 'Reduza distrações, defina blocos curtos e acompanhe seus indicadores por semana.'
  };
}

export function strategicScore(answers: string[]) {
  const map: Record<string, number> = { Sim: 10, Talvez: 5, Não: 1 };
  return answers.reduce((sum, answer) => sum + (map[answer] || 0), 0);
}
